/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AlterarSenhaAliases {
  BUTTON_ALT_SENHA = 'button-alt-senha',
  BUTTON_OK = 'button-ok',
  FIELD_NOVA_SENHA = 'field-nova-senha',
  FIELD_NOVA_SENHA_CONFIRM = 'field-nova-senha-confirm',
  FIELD_SENHA_ATUAL = 'field-senha-atual',
  FORM_ALT_SENHA = 'form-alt-senha',
  IMAGE_0 = 'image-0',
  INPUT_NOVA_SENHA = 'input-nova-senha',
  INPUT_NOVA_SENHA_CONFIRM = 'input-nova-senha-confirm',
  INPUT_SENHA_ATUAL = 'input-senha atual',
  LAYOUT_0 = 'layout-0',
  LAYOUT_1 = 'layout-1',
  LAYOUT_2 = 'layout-2',
  LOADER = 'loader',
  MODAL_SENHAS = 'modal-senhas',
  MODAL_SUCCESS = 'modal-success',
  PANEL_2 = 'panel-2',
  PANEL_4 = 'panel-4',
  PANEL_BTN = 'panel-btn',
  PANEL_FORM = 'panel-form',
  PANEL_LOADER = 'panel-loader',
  PANEL_MODAL = 'panel-modal',
  PANEL_SUCCESS = 'panel-success',
  TEXT_2 = 'text-2',
  TOAST_NOTIFICATION = 'toast-notification',
}
export { AlterarSenhaAliases };
